import { PropsWithChildren } from 'react';
import { observer } from 'mobx-react-lite';
import { IntegratedBoloPanelProvider } from '../../bolos/bolo-panel/state/integrated-bolo-panel-provider';

export const FrBoloProviders = observer(
    ({ children, boloId }: PropsWithChildren<{ boloId?: number }>) => {
        return (
            <IntegratedBoloPanelProvider boloId={boloId}>{children}</IntegratedBoloPanelProvider>
        );
    }
);
